import React, { useEffect, useState } from "react";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderR } from "../routes";
import { ServiceProviderTabs } from "../../../molecules/service-provider-tab";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { BaseProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";
import { GrafferManagedTag, toTotalPage } from "@graffer-inc/smart-apply";
import apiClient from "../../../../application/apis/api-client";
import {
  parseQueryOfLocation,
  rebuildQuery,
} from "../../../../utils/url-utils";
import {
  DefaultNumItemsPerPages,
  paging,
} from "../../../../application/domain/pagination/paging";
import { Pagination } from "@graffer-inc/console-design-kit";
import { Loader } from "../../../organisms/common/loading";
import { ProceduresSearchWindow } from "../../../organisms/smart-apply/procedure-list/procedures-search-window";

export const OrganizationArchivedProceduresList: React.FC = () => {
  const { id: orgId } = useParams<{ id: string }>();
  const history = useHistory();
  const [archivedProcedures, setArchivedProcedures] = useState<
    BaseProcedureEntity[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { page, name } = parseQueryOfLocation(useLocation()) as {
    page: string | undefined;
    name: string | undefined;
  };
  const [paging, setPaging] = useState<paging>({
    current: 1,
    total: 0,
  });
  const [searchName, setSearchName] = useState<string>(name ?? "");

  useEffect(() => {
    setIsLoading(true);
    const currentPage = page ? parseInt(page) : 1;
    const fetchArchivedProcedures = async () => {
      const { data: procs, headers } =
        await apiClient.fetchArchivedProceduresByOrgId(
          orgId,
          currentPage,
          DefaultNumItemsPerPages,
          {
            name: name,
          },
        );
      setPaging({
        current: currentPage,
        total: toTotalPage(
          Number(headers["pagination-count"]),
          DefaultNumItemsPerPages,
        ),
      });
      setArchivedProcedures(procs);
      setIsLoading(false);
    };
    fetchArchivedProcedures();
  }, [page, name, orgId]);

  const movePage = (p: number) => {
    history.push(
      rebuildQuery({
        page: p.toString(),
        name: searchName,
      }),
    );
  };

  const searchArchivedProcedures = (name: string | undefined) => {
    history.push(
      rebuildQuery({
        page: "1",
        name: name,
      }),
    );
  };

  return (
    <ServiceProviderTemplate
      breadcrumbs={[{ to: ServiceProviderR.Home.link({}), title: "Home" }]}
    >
      <div className="has-text-left">
        <div className="columns">
          <div className="column">
            <ServiceProviderTabs orgId={orgId} />
            <div className="columns">
              <div className="column">
                <ProceduresSearchWindow
                  searchName={searchName}
                  setSearchName={setSearchName}
                  searchProcedures={searchArchivedProcedures}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader isLoading={isLoading}>
        <table className="table is-fullwidth mt-5">
          <thead>
            <tr>
              <th>手続きID</th>
              <th>手続き名称</th>
            </tr>
          </thead>
          <tbody>
            {archivedProcedures?.map((archivedProcedure) => (
              <tr
                key={archivedProcedure.id}
                className="c-tr-selectable c-tr-has-tag"
                onClick={() =>
                  history.push(
                    ServiceProviderR.ProcedureDetail.link({
                      orgId: orgId,
                      procedureId: archivedProcedure.id,
                    }),
                  )
                }
              >
                <td>{archivedProcedure.id}</td>
                <td>
                  {archivedProcedure.name}
                  {archivedProcedure.isGrafferManaged && (
                    <>
                      &nbsp; &nbsp;
                      <GrafferManagedTag />
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Loader>
      <div style={{ marginTop: "16px" }}>
        <Pagination
          onPageClick={movePage}
          currentPage={paging.current}
          lastPage={paging.total}
        />
      </div>
    </ServiceProviderTemplate>
  );
};
